'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

import { Logo } from '@/components/sections/logo'
import {
  getInPageAnchorId,
  normalizeAnchor,
  normalizeSectionId,
} from '@/components/sections/section-utils'
import { Container } from '@/components/sections/container'

function normalizeLinks(links) {
  if (!Array.isArray(links)) {
    return []
  }

  return links
    .map((link) => ({
      label: String(link?.label || '').trim(),
      href: normalizeAnchor(link?.link?.url || link?.anchorId || link?.url || '', '#'),
    }))
    .filter((item) => item.label && item.href)
}

export function FooterSection({ section }) {
  const pathname = usePathname()
  const sectionId = normalizeSectionId(section, 'footer')
  const brandName = section?.brandName || 'Catchment'
  const navLinks = normalizeLinks(section?.navLinks)
  function handleAnchorClick(event, href) {
    const targetId = getInPageAnchorId(href, pathname)

    if (!targetId) {
      return
    }

    event.preventDefault()

    const target = document.getElementById(targetId)
    if (!target) {
      return
    }

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  return (
    <footer id={sectionId} className="bg-light/15">
      <Container>
        <div className="py-16">
          <Logo className="mx-auto h-10 w-auto" />
          <nav className="mt-10 text-sm" aria-label="quick links">
            <div className="-my-1 flex justify-center gap-x-6">
              {navLinks.map((link, index) => (
                <Link
                  href={link.href}
                  key={`${link.label}-${index}`}
                  className="inline-block rounded-lg px-2 py-1 text-sm text-primary hover:bg-light/20 hover:text-dark"
                  onClick={(event) => handleAnchorClick(event, link.href)}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </nav>
        </div>
        <div className="border-t border-mid/20 py-10">
          <p className="text-center text-sm text-mid">
            {section?.copyright ||
              `© ${new Date().getFullYear()} ${brandName}. All rights reserved.`}
          </p>
        </div>
      </Container>
    </footer>
  )
}
